<script setup>
import { ref, onMounted, defineExpose, getCurrentInstance } from "vue";
import { useRouter } from 'vue-router'
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import jobFairCorpService from "@/pages/user/services/jobFair/jobFairCorpService";
import KSAPrimaryButton from "@/components/ui-components/button/KSAPrimaryButton.vue";
import JobFairJobNoticeModal from "@/pages/user/components/modal/jobFair/JobFairJobNoticeModal.vue";
const loadingStore = usePageLoadingStore()
const { $pageListBoardNo, $number, $yyyymmddHHmmss } = getCurrentInstance().appContext.config.globalProperties;

const router = useRouter()

const ojfId = ref(0);
const resumeId = ref(0);
const modes = ref('');

const jobNoticeList = ref([]);
const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(1);
const totalCount = ref(0);

const baseModal = ref(null);
const resolvePromise = ref(null);

const alertModal = ref(null);
const confirmModal = ref(null)
const jobNoticeModal = ref(null);
const modalContent = ref([])
const okButtonText = ref("네");
const cancelButtonText = ref("아니오");

onMounted(()=>{
  setTimeout(()=>{
    baseModal.value.isAdminWrap = true;
  }, 500);
})

// 면접제안 시 채용공고 목록 조회
const interviewProposalJobNoticeList = (_ojfId, _resumeId, mode) => {
  ojfId.value = _ojfId;
  resumeId.value = _resumeId;
  modes.value = mode;

  let paramObj = {
    ojfId: ojfId.value,
    resumeId: resumeId.value,
    pageNumber: currentPage.value,
    size: pageSize.value,
  };

  loadingStore.loading = true;
  jobFairCorpService.ojfCropInterviewProposalJobNoticeList(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          jobNoticeList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      }).catch( (error) =>  {
    loadingStore.loading = false;
    console.log(error);
  });
}

// 면접제안
const onClickInterviewProposal = async (ojfId, resumeId, jobNoticeSeq) => {
  modalContent.value = ["선택한 채용공고로", "면접제안을 하시겠습니까?"];
  okButtonText.value = "면접제안";

  const ok = await confirmModal.value.show();
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      ojfId: ojfId,
      resumeId: resumeId,
      jobNoticeSeq: jobNoticeSeq,
    }

    loadingStore.loading = true;
    jobFairCorpService.ojfCropInterviewProposalCreate(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            modalContent.value = ["면접제안을 하였습니다."];
            alertModal.value.show();

            interviewProposalJobNoticeList(ojfId, resumeId);
          } else {
            modalContent.value = ["면접제안을 실패하였습니다."];
            alertModal.value.show();
          }
        }).catch( (error) =>  {
      loadingStore.loading = false;
      modalContent.value = ["제안을 실패하였습니다."];
      alertModal.value.show();
      console.log(error);
    });
  }
}

// 채용공고 보기
const onClickJobNotice = async (ojfId, corpId, jobNoticeSeq, resumeId, inteYn) => {
  // inteYn (list.resumeId) : 채용공고 선택 목록 데이터에서 resumeId에 데이터가 있으면 제안완료로 체크 (버튼 활성화/비활성화를 위한 데이터)

  const mode = modes.value;

  jobNoticeModal.value.init(false, false, true, ojfId, resumeId, inteYn, 0, 0, 0, mode);
  jobNoticeModal.value.ojfCropJobNoticeDetail(jobNoticeSeq);
  jobNoticeModal.value.ojfCorpRecruitmentHall(ojfId, corpId);
  jobNoticeModal.value.ojfCorporationDetail(corpId);
  await jobNoticeModal.value.show();

  interviewProposalJobNoticeList(ojfId, resumeId);
}

const show = () => {
  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const confirm = () => {
  baseModal.value.close();
  resolvePromise.value(true);
};

const init = () => {
  currentPage.value = 1;
}

const cancel = () => {
  baseModal.value.close();
  resolvePromise.value(false);
};

const onSelectedPage = (pageNo) => {
  currentPage.value = pageNo;
  interviewProposalJobNoticeList(ojfId.value, resumeId.value);
}

defineExpose({
  init,
  show,
  interviewProposalJobNoticeList,
})
</script>

<template>
  <Modal ref="baseModal">
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-title">
        <h3>채용공고 선택</h3>
        <p>
          기존 등록된 채용공고를 선택하여 인재에게 면접제안을 할 수 있습니다.<br>
          새로운 채용공고 작성을 원하실 경우 [새로운 채용공고 등록하기]를 눌러주세요.
        </p>
      </div>
      <div class="modal-body">
        <div class="list-top">
          <p>총 <span>{{ $number(totalCount)}}</span>개</p>
        </div>
        <div class="table-form">
          <table class="vertical" v-if="jobNoticeList !== null">
            <colgroup>
              <col width="50px" />
              <col />
              <col width="220px" />
              <col width="220px" />
              <col width="50px" />
            </colgroup>
            <tr>
              <th class="text-center">번호</th>
              <th class="text-center">채용공고 제목</th>
              <th class="text-center">최근 수정일</th>
              <th class="text-center">등록일</th>
              <th class="text-center">선택</th>
            </tr>
            <tr v-for="list in jobNoticeList">
              <td class="text-center">{{ list.boardNo }}</td>
              <td class="text-center text-overflow long-overflow">
                <p class="clickable" @click="onClickJobNotice(ojfId, list.corpId, list.jobNoticeSeq, resumeId, list.resumeId)">{{ list.jobName }}</p>
              </td>
              <td class="text-center">{{ $yyyymmddHHmmss(list.modifyDate) }}</td>
              <td class="text-center">{{ $yyyymmddHHmmss(list.createDate) }}</td>
              <td class="link text-center">
                <!-- 채용공고 선택 목록 데이터에서 resumeId에 데이터가 있으면 제안완료로 체크 (버튼 활성화/비활성화를 위한 데이터) -->
                <KSAPrimaryButton v-if="list.resumeId" text="제안완료" disabled="disabled" />
                <KSATextButton text="선택" v-else @click="onClickInterviewProposal(ojfId, resumeId, list.jobNoticeSeq)" />
              </td>
            </tr>
            <tr v-if="jobNoticeList.length === 0">
              <td class="text-center" colspan="5">
                등록된 채용공고가 없습니다.
              </td>
            </tr>
            <tr>
              <th class="text-left" style="font-weight: 400;"></th>
              <th colspan="4" class="link text-right" style="font-weight: 400; ">
                <KSATextButton text="[새로운 채용공고 등록하기]" @click="router.push({ name: 'MyPageCorpJobNoticeCreat', query : { ojfId: ojfId, resumeId: resumeId, mode: modes }})" />
              </th>
            </tr>
          </table>
        </div>
        <Paginate
            v-if="jobNoticeList.length > 0"
            v-model="currentPage"
            :page-count="totalPages"
            :click-handler="onSelectedPage"
        />
      </div>
      <div class="modal-footer mt-xs" style="justify-content: center;">
        <KSASecondaryButton class="gray_button" text="취소" @click="cancel" />
      </div>
    </div>
  </Modal>
  <AlertModal ref="alertModal" :content="modalContent" />
  <ConfirmModal ref="confirmModal" :content="modalContent" :okButtonText="okButtonText" :cancelButtonText="cancelButtonText" />
  <JobFairJobNoticeModal ref="jobNoticeModal"/> <!-- 채용공고 상세 -->
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.modal-inner {
  width: 598px !important;
}

.modal-title p span {
  color: $red_color;
  font-weight: 700;
}

.list-top {
  p {
    margin-right: 0;
    padding-left: 2px;
    &:first-of-type {
      padding-left: 0;
    }
  }
}

.table-form {
  p {
    margin-bottom: 0 !important;
  }
  .clickable {
    text-decoration: underline;
    cursor: pointer;
    color: $blue_color !important;
  }
}

</style>